import { BodyPlacement } from "./BodyPlacement";
import { Z_INDEX_LAYER_SIZE } from "../helpers/consts";
import Hero from "../components/object-graphics/Hero";
import { Collision } from "../classes/Collision";
import sounds, { SFX } from "../classes/Sounds";

const DELAY_FRAMES_AFTER_UNLOCKING_DOOR = 16;

export class HeroPlacement extends BodyPlacement {
  controllerMoveRequested(direction) {
    // Do not move if we are still locked from previous move
    const isAddlFrames = this.postMovementLockedFrames > 0;
    if (isAddlFrames && this.level.isPlayingMode) {
      return;
    }

    // Check for unlocking a Lock
    const possibleLock = this.getLockAtNextPosition(direction);
    if (possibleLock) {
      this.postMovementLockedFrames = DELAY_FRAMES_AFTER_UNLOCKING_DOOR;
      possibleLock.unlock();
      sounds.playSfx(SFX.UNLOCK);
      return;
    }

    // Deny request if frozen or we are moving
    const isOnAutomaticMovementTile =
      this.autoMovementLockedFrames > 0 && this.level.isPlayingMode;
    if (isOnAutomaticMovementTile || !this._nextSpaceIsFree(direction)) {
      return;
    }

    //Default to move
    this._move(direction);
  }

  getLockAtNextPosition(direction) {
    const nextSpace = new Collision(this, this.level);
    nextSpace.offsetPositionInDirection(this.x, this.y, direction);
    return nextSpace.withDoorThatCanBeUnlocked();
  }

  takeDamage(fromBody) {
    if (this.level.isLevelCompleted || this.level.isEditMode) {
      return;
    }
    this.level.setDeathType(fromBody.type);
  }

  getZIndex() {
    return this.y * Z_INDEX_LAYER_SIZE + 1; //Hero is +1 above anything else in the layer
  }

  renderComponent() {
    return (
      <Hero
        movingPixelsRemaining={this.movingPixelsRemaining}
        direction={this.facingDirection}
        skin={this.skin}
        heroDeath={this.level.heroDeath}
        isEditMode={this.level.isEditMode}
        walkFrame={this.walkFrame}
      />
    );
  }
}
